import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ContratoService} from '../../superadmin/services/contrato.service';

@Component({
  selector: 'app-assinatura-pix-autorizacao',
  templateUrl: './assinatura-pix-autorizacao.component.html',
  styleUrls: ['./assinatura-pix-autorizacao.component.scss']
})
export class AssinaturaPixAutorizacaoComponent implements OnInit, OnDestroy {
  private polling: any;
  private destruido = false;
  autorizacao: any;
  carregando = false;
  erro: string;
  readonly mensagens = {
    PENDING: 'Aguardando sua autorização no banco.',
    AWAITING_DEBTOR: 'Aguardando sua autorização no banco.',
    CONFIRMED: 'Pix Automático autorizado. Os próximos débitos seguirão as condições autorizadas no banco.',
    ERROR: 'A autorização não foi concluída. Solicite um novo link ao responsável pela assinatura.',
    REJECTED: 'A autorização foi recusada. Solicite um novo link ao responsável pela assinatura.',
    EXPIRED: 'Esta autorização expirou. Solicite um novo link ao responsável pela assinatura.',
    CANCELLED: 'Esta autorização foi cancelada.',
    CANCELLATION_REQUESTED: 'O cancelamento desta autorização está em andamento.'
  };
  readonly frequencias = {
    MONTHLY: 'Mensal', QUARTER: 'Trimestral', SEMESTER: 'Semestral', YEARLY: 'Anual'
  };

  constructor(private contratoService: ContratoService, private route: ActivatedRoute) {}

  ngOnInit(): void { this.atualize(); }

  ngOnDestroy(): void {
    this.destruido = true;
    clearTimeout(this.polling);
  }

  async atualize(): Promise<void> {
    if(this.carregando || this.destruido) return;
    clearTimeout(this.polling);
    this.carregando = true;
    this.erro = null;
    try {
      const autorizacao = await this.contratoService.obtenhaAutorizacaoPix(this.route.snapshot.params.codigo);
      if(!this.destruido) this.autorizacao = autorizacao;
    } catch(erro) {
      this.erro = 'Não foi possível consultar este link. Tente novamente ou solicite um novo link ao responsável pela assinatura.';
    } finally {
      this.carregando = false;
      if(!this.destruido && (!this.autorizacao ||
        ['PENDING', 'AWAITING_DEBTOR', 'PENDING_DEBIT_PARTY', 'CANCELLATION_REQUESTED'].includes(this.autorizacao.status)))
        this.polling = setTimeout(() => this.atualize(), 10000);
    }
  }
}
